module.exports = __webpack_public_path__ + "static/media/unarchive.a5c5cb7e.svg";